if (!customElements.get('product-promotion-alert')) {
  customElements.define(
    'product-promotion-alert',
    class ProductPromotionAlert extends HTMLElement {
      constructor() {
        super()

        this.closeBtn = this.querySelector('button')
        this.closeBtn?.addEventListener('click', this.remove.bind(this))
      }
    }
  )
}